<template>
	<header>
		<div class="header-items">
			<span v-if="show">
				<span>{{ user.name }}</span>
				<router-link to="/search">{{ translation.navbar.makeBookings }}</router-link>
				<router-link to="/see-your-bookings">{{ translation.navbar.seeBookings }}</router-link>
				<span><a href="" @click="logout">{{ translation.navbar.exit }}</a></span>
			</span>
		</div>
		<div class="header-bar">
			<div class="languages">
				<img src="/static/flag_br.jpg" @click="setLanguage(Language.PORTUGUESE)">
				<img src="/static/flag_en.jpg" @click="setLanguage(Language.ENGLISH)">
				<img src="/static/flag_sp.jpg" @click="setLanguage(Language.SPANISH)">
			</div>
		</div>
	</header>
</template>

<script>
import { translate } from '../../assets/translations';
import Language from '../../enums/Language';

export default {
	data() {
		return {
			Language,
		};
	},
	computed:{
		translation() {
			return translate(this.$store.state.language);
		},
		show() {
      return this.$route.name !== "login";
    },
		user() {
			return JSON.parse(window.localStorage.getItem('user'));
		}
	},
	methods: {
		logout() {
			this.$store.dispatch("logout");
			this.$router.push("/login");
		},
		setLanguage(language) {
			this.$store.dispatch('language', language);
		}
	}
}
</script>

<style scoped lang="scss">
.header-items {
	text-align: center;
	margin: 20px 0px;
	min-height: 40px;

	*:not(:last-child) {
		border-right: 1px #163247 solid;
		padding-right: 5px;
	}
}

.header-bar {
	background-color: #163247;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.languages {
	width: fit-content;
  margin-right: 1%;
  cursor: pointer;
	img {
		border-radius: 50%;
	}
}

.btn-cart {
	background: linear-gradient(180deg, rgba(213,213,213,1) 0%, rgba(238,238,236,1) 100%);
  border-style: none;
  color: #163247;
  height: 30px;
  margin-left: 70%;
	display: flex;
  gap: 5px;
  align-items: center;
}

.badge {
  padding: 3px 11px;
	border-radius: 10px;
  font-size: 11.844px;
  line-height: 14px;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0,0,0,0.25);
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #999;
}
</style>../../assets/translations../../enums/Language



// WEBPACK FOOTER //
// src/components/shared/Header.vue